import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSym = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#sym_svg__a)'>
      <path fill='#E6E9F0' d='M24 12q0 12-12 12T0 12 12 0t12 12' />
      <path
        fill='url(#sym_svg__b)'
        fillRule='evenodd'
        d='M19.258 8.62c-.036-.525-.493-2.953-1.456-1.855-.747.845-.528 2.45-.746 3.477-.262 1.23-1.345 2.92-2.804 1.957-1.37-.903-.963-2.784-1.421-4.113-.525-1.51-1.989-1.783-3.397-1.791-1.245-.007-3.125-.26-4.208.492-1.484 1.03 1.528 1.535 2.06 1.586 1.108.102 2.792.284 3.345 1.433.995 2.069-1.969 2.605-3.277 2.771-1.916.246-3.022 1.736-2.602 3.666.133.615.529 1.76 1.388 1.353.605-.29.615-1.375.95-1.895a2.02 2.02 0 0 1 2.429-.803c.882.35 1.192 1.085 1.465 1.922.214.66.926 1.302 1.6.678.5-.464.473-1.31.86-1.866a2.066 2.066 0 0 1 2.412-.738c.814.321 1.126 1.047 1.39 1.816.217.63.843 1.415 1.485.66.568-.667.572-1.748.57-2.568 0-2.051.103-4.13-.04-6.177z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <linearGradient
        id='sym_svg__b'
        x1={12}
        x2={12}
        y1={17.752}
        y2={6.249}
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#7C89A3' stopOpacity={0.4} />
        <stop offset={1} stopColor='#7C89A3' stopOpacity={0.3} />
      </linearGradient>
      <clipPath id='sym_svg__a'>
        <path fill='#fff' d='M0 0h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgSym)
export default ForwardRef
